import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "pageLayout"
};
const _hoisted_2 = {
  class: "options"
};
const _hoisted_3 = {
  class: "displayOption"
};
const _hoisted_4 = {
  class: "displayOption"
};
const _hoisted_5 = {
  class: "exportStatus"
};
const _hoisted_6 = {
  class: "_gridLayout"
};
const _hoisted_7 = {
  key: 0,
  class: "progressPanel"
};
const _hoisted_8 = {
  style: {
    "text-align": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_select = _resolveComponent("w-select");
  const _component_w_toggle = _resolveComponent("w-toggle");
  const _component_el_button = _resolveComponent("el-button");
  const _component_standard_speach_card = _resolveComponent("standard-speach-card");
  const _component_el_progress = _resolveComponent("el-progress");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[6] || (_cache[6] = _createElementVNode("div", {
    class: "title"
  }, "Export Mass SCORM", -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[2] || (_cache[2] = _createTextVNode(" Export type : ", -1)), _createVNode(_component_w_select, {
    value: "SCORM_LITE",
    options: _ctx.types,
    modelValue: _ctx.typeSelected,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.typeSelected = $event)
  }, null, 8, ["options", "modelValue"])]), _createElementVNode("div", _hoisted_4, [_cache[3] || (_cache[3] = _createTextVNode(" Navigation In content : ", -1)), _createVNode(_component_w_toggle, {
    value: false,
    modelValue: _ctx.navigationInContent,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.navigationInContent = $event)
  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_5, [_createTextVNode("Number of speach to export : " + _toDisplayString(_ctx.listOfSpeach.length) + " ", 1), _createVNode(_component_el_button, {
    type: "primary",
    onClick: _ctx.startDownload
  }, {
    default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("Download Scorms", -1)])),
    _: 1,
    __: [4]
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfSpeach, speach => {
    return _openBlock(), _createBlock(_component_standard_speach_card, {
      speach: speach,
      key: speach.speachID,
      class: "speachCard"
    }, null, 8, ["speach"]);
  }), 128))]), _ctx.currentSpeachToExport > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, _toDisplayString(_ctx.currentSpeachToExport) + " / " + _toDisplayString(_ctx.listOfSpeach.length), 1), _createVNode(_component_el_progress, {
    type: "circle",
    percentage: Math.round((_ctx.currentSpeachToExport - 1) / _ctx.listOfSpeach.length * 100)
  }, null, 8, ["percentage"]), _createElementVNode("div", null, [(_openBlock(), _createBlock(_component_standard_speach_card, {
    speach: _ctx.listOfSpeach[_ctx.currentSpeachToExport - 1],
    key: _ctx.listOfSpeach[_ctx.currentSpeachToExport - 1].speachID,
    class: "speachCard"
  }, null, 8, ["speach"]))]), _createVNode(_component_el_button, {
    type: "danger",
    onClick: _ctx.cancelExport,
    style: {
      "margin-top": "48px"
    }
  }, {
    default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("Cancel", -1)])),
    _: 1,
    __: [5]
  }, 8, ["onClick"])])])) : _createCommentVNode("", true)]);
}